class ScrollingIconMarquee extends HTMLElement {
  connectedCallback() {
    this._track = this.querySelector(".scrolling-icon-track");
    this._sets = this.querySelectorAll(".scrolling-icon-set");

    if (!this._track || this._sets.length < 2) return;

    this._sourceHTML = this._sets[0].innerHTML;
    this._rafId = null;
    this._onResize = this._onResize.bind(this);
    this._onLoad = this._fillTrack.bind(this);

    this._fillTrack();

    if (document.readyState !== "complete") {
      window.addEventListener("load", this._onLoad, { once: true });
    }

    window.addEventListener("resize", this._onResize);

    if (window.ResizeObserver) {
      this._resizeObserver = new ResizeObserver(this._onResize);
      this._resizeObserver.observe(this);
    }
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this._onResize);
    window.removeEventListener("load", this._onLoad);

    if (this._rafId) {
      cancelAnimationFrame(this._rafId);
      this._rafId = null;
    }

    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }
  }

  _onResize() {
    if (this._rafId) cancelAnimationFrame(this._rafId);
    this._rafId = requestAnimationFrame(() => this._fillTrack());
  }

  _fillTrack() {
    if (!this._sets || this._sets.length < 2) return;

    var need = this.clientWidth;
    if (!need) return;

    this._sets[0].innerHTML = this._sourceHTML;
    this._sets[1].innerHTML = this._sourceHTML;

    var guard = 0;
    while (this._sets[0].scrollWidth < need && guard < 30) {
      this._sets[0].insertAdjacentHTML("beforeend", this._sourceHTML);
      this._sets[1].insertAdjacentHTML("beforeend", this._sourceHTML);
      guard += 1;
    }
  }
}

if (!window.customElements.get("scrolling-icon-marquee")) {
  window.customElements.define("scrolling-icon-marquee", ScrollingIconMarquee);
}
